import { useTranslation } from 'react-i18next'

import { Button, Flex, Text } from '@chakra-ui/react'

interface DeviceTraceLogsEmptyStatePropsI {
  /** Omitted when the incident has no Facility to fall back to. */
  onViewFacility?: () => void
}

/**
 * Device tab content when the device has no trace log events (ENG-33914).
 * Cameras and other non-ACS devices often have none, so point the operator
 * at the Facility tab instead of leaving a blank panel.
 */
export const DeviceTraceLogsEmptyState = ({
  onViewFacility,
}: DeviceTraceLogsEmptyStatePropsI) => {
  const { t } = useTranslation()

  return (
    <Flex
      alignItems='center'
      data-testid='traceLog_deviceEmptyState'
      direction='column'
      gap='12px'
      py='32px'
      textAlign='center'
    >
      <Text fontSize='14px' fontWeight='500'>
        {t('incidents:drawer_trace_log_device_empty_title')}
      </Text>
      <Text color='text.secondary' fontSize='14px'>
        {t('incidents:drawer_trace_log_device_empty_description')}
      </Text>
      {onViewFacility && (
        <Button onClick={onViewFacility} size='sm' variant='outline'>
          {t('incidents:drawer_trace_log_view_facility')}
        </Button>
      )}
    </Flex>
  )
}
